import { Organization } from './organization.model';
import { Project } from './project.model';
import { Task } from './task.model';
import { User } from './user.model';
import { Note } from './note.model';
import { PunchClock } from './punchClock.model';
import { Incident } from './incident.model';
import { BudgetRequest, BudgetProposal } from './budget.model';

export const ACTIVITY_TYPE_INVOICE_PENDING = 'INVOICE_PENDING';

export enum ActivityResolutionStatus {
  ACTIVE = 'ACTIVE',
  RESOLVED = 'RESOLVED',
}

export enum ActivityCreationTrigger {
  USER_COMPLETION = 'USER_COMPLETION',
  SYSTEM_DETECTED = 'SYSTEM_DETECTED',
}

export interface PendingItemSnapshotEntry {
  itemId: string;
  itemType: 'MATERIAL' | 'EQUIPMENT';
  source: 'LEGACY_FK' | 'JUNCTION';
  name?: string;
}

export interface Activity {
  activityId?: string;
  type: string;
  name?: string;
  organizationId: string;
  time?: string | Date | null;
  category?: string;
  description?: string;
  documents?: {
    url: string;
  }[];
  newStatus?: string;
  newPercentage?: number;
  projectId?: string;
  userId?: string;
  taskId?: string;
  createdAt?: string | Date | null; // Pattern A: Auto-generated timestamp
  attemptAt?: string | Date | null; // Pattern C: User-supplied timestamp with timezone
  noteId?: string;
  note?: Note;
  punchClockId?: string;
  punchClock?: PunchClock;
  incidentId?: string;
  incident?: Incident;
  budgetRequestId?: string;
  budgetRequest?: BudgetRequest;
  budgetProposalId?: string;
  budgetProposal?: BudgetProposal;
  user: User;
  task: Task;
  organization?: Organization;
  project?: Project;
  // StatusHistory fields for enhanced status change activities
  statusHistoryId?: string;
  statusHistory?: {
    statusHistoryId: string;
    previousStatus?: string;
    newStatus: string;
    reason?: string;
    createdAt: string;
    user: {
      firstName: string;
      lastName: string;
    };
    task: {
      taskId: string;
      name: string;
    };
  };

  // INVOICE_PENDING subtype fields. Populated only when type === ACTIVITY_TYPE_INVOICE_PENDING.
  resolutionStatus?: ActivityResolutionStatus;
  creationTrigger?: ActivityCreationTrigger;
  pendingItemsSnapshot?: PendingItemSnapshotEntry[];
}

export interface getActivitiesRequest {
  getActivities: Activity[];
}

export interface createOrUpdateActivitiesRequest {
  updateActivity?: Activity;
}

export interface deleteActivityRequest {
  deleteActivity: {
    affected: number;
  };
}
